<div khA11yDialog>
<div class="modal-heading modal-heading-1">
	<div khA11yLabelSource class="label_name">{{ 'SELECT_UPLOAD_SOURCE.UPLOAD_SOLUTION' | translate }}</div>
</div>

<div class="modal-body p-0">
	<div khA11yClickable class="upload-modal__option" (click)="useWebCam()">
		<div khA11yLabelSource class="upload-modal__option-title">{{ 'SELECT_UPLOAD_SOURCE.USE_WEBCAM' | translate }}</div>
		<div khA11yDescriptionSource class="upload-modal__option-subtitle">{{ 'SELECT_UPLOAD_SOURCE.CHROMEBOOKS_LAPTOPS' | translate }}</div>
	</div>
	<div khA11yClickable class="upload-modal__option" (click)="fileInput.click()">
		<div khA11yLabelSource class="upload-modal__option-title">{{ 'SELECT_UPLOAD_SOURCE.PHONE_CAMERA' | translate }}</div>
		<div khA11yDescriptionSource class="upload-modal__option-subtitle">{{ 'SELECT_UPLOAD_SOURCE.PHONES_TABLETS_OR' | translate }} <span class="ul">{{ 'SELECT_UPLOAD_SOURCE.UPLOAD_A_FILE' | translate }}</span></div>
	</div>
</div>

<div class="modal-footer upload-modal__footer justify-content-end">
	<button type="button" class="btn btn-default" (click)="cancel()" data-dismiss="modal">{{ 'SELECT_UPLOAD_SOURCE.CANCEL' | translate }}</button>
</div>

<input class="d-none" type="file" (change)="uploadFile($event)" #fileInput [accept]="acceptedExtensions" [khA11yLabel]="'SELECT_UPLOAD_SOURCE.UPLOAD_A_FILE' | translate">
</div>
